import { action, computed, makeObservable } from 'mobx';
import { BonusViewType } from 'src/api_openapi/v2/bonus-engine/schemas';
import { CreditsState } from '../Credits.state';

export class CreditsBetSpinsCardState {
    public constructor(
        private readonly bonus: BonusViewType,
        private readonly creditsState: CreditsState
    ) {
        makeObservable(this);
    }

    @action public redirectToSportsbook = (): void => {
        const sportUsageCondition = this.sportUsageCondition;
        this.creditsState.redirectToSportsbook(sportUsageCondition);
    };

    @computed public get sportUsageCondition(): string[] {
        return this.bonus.usageConditions?.find((el) => el.type === 'sport')?.value as string[];
    }

    @computed public get amount(): number | null | undefined {
        return this.bonus.status === 'active' ? this.bonus.currentAmount : this.bonus.totalAmount;
    }

    @computed public get termType(): 'bonus-creation' | 'campaign' {
        return this.bonus.campaignId === null ? 'bonus-creation' : 'campaign';
    }

    @computed public get termId(): string | null | undefined {
        return this.bonus.campaignId === null ? this.bonus.bonusCreationId : this.bonus.campaignId;
    }
}
